
import React, { useState } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {LayoutFieldModel} from '../../models/models';
import {checkLayoutFieldRequirement} from '../../utils/fieldValidations';

export const FormulaFieldComponent: React.FC<{
  layoutField: LayoutFieldModel,
  value: string,
}> = ( {
  layoutField,
  value
}) => {


  return (
      <TextField
         fullWidth
         error={false}
         disabled={true}
         required={false}
         size="small"
         label={layoutField.ReferencedField_sys.Label_sys}
         variant="filled"
         value={value}
         onChange={() => {}}
         helperText={layoutField.ReferencedField_sys.HelpText_sys}
      />

    );

};
